import React, { useState, Fragment } from "react";
import { Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import PersonalInformationSchema from "./ValidationSchema/PersonalInformationSchema";
import PhoneInput from "../UI Component/PhoneInput/PhoneInput";
import API_Call from "../../Util/API Calls/afterLogin";
import Loader from "../UI Component/Loader/Loader";
import swal from "sweetalert";
import { useEffect } from "react";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import internalServerError from "../Admin/Errors/IntenalServerError";
import Select from "react-select";
import { withRouter } from "react-router";

const PersonalInformation = (props) => {
  const [redo, setredo] = useState(0);
  const [state, setState] = useState({
    submitPersonalInformation: false,
    specifyOthers: props.isFilled.submitPersonalInformation
      ? props.isFilled.doctor_specialization_id == "999999"
        ? true
        : false
      : false,
    specifiedSpecilization: props.isFilled.submitPersonalInformation
      ? props.isFilled.specifiedSpecilization
      : "",
    loading: false,
    step: 1,
    selectedSpecialisation: "",
    state_code: props.isFilled.submitPersonalInformation
      ? props.isFilled.state_code
      : Number,
    specializationError: false,
    otherSpecializationError: false,
    doctorCategories: [],
    selectState: [
      { label: "Andhra Pradesh", value: 37 },
      { label: "Arunachal Pradesh", value: 12 },
      { label: "Assam", value: 18 },
      { label: "Bihar", value: 10 },
      { label: "Chattisgarh", value: 22 },
      { label: "Delhi", value: 7 },
      { label: "Goa", value: 30 },
      { label: "Gujarat", value: 24 },
      { label: "Haryana", value: 6 },
      { label: "Himachal Pradesh", value: 2 },
      { label: "Jammu and Kashmir", value: 1 },
      { label: "Jharkhand", value: 20 },
      { label: "Karnataka", value: 29 },
      { label: "Kerala", value: 32 },
      { label: "Lakshadweep Islands", value: 31 },
      { label: "Madhya Pradesh", value: 23 },
      { label: "Maharashtra", value: 27 },
      { label: "Manipur", value: 14 },
      { label: "Meghalaya", value: 17 },
      { label: "Mizoram", value: 15 },
      { label: "Nagaland", value: 13 },
      { label: "Odisha", value: 21 },
      { label: "Pondicherry", value: 34 },
      { label: "Punjab", value: 3 },
      { label: "Rajasthan", value: 8 },
      { label: "Sikkim", value: 11 },
      { label: "Tamil Nadu", value: 33 },
      { label: "Telangana", value: 36 },
      { label: "Tripura", value: 16 },
      { label: "Uttar Pradesh", value: 9 },
      { label: "Uttarakhand", value: 5 },
      { label: "West Bengal", value: 19 },
      { label: "Andaman And Nicobar Islands", value: 35 },
      { label: "Chandigarh", value: 4 },
      { label: "Dadra and Nagar Haveli", value: 26 },
      { label: "Daman and Diu", value: 25 },
      { label: "Ladakh", value: 38 },
    ],
  });
  const initialFieldValues = {
    prefix_name: props.isFilled.submitPersonalInformation
      ? props.isFilled.prefix_name
      : "",
    first_name: props.dsmOnboarding
      ? props.dsmOnboarding.first_name
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.first_name
      : "",
    middle_name: props.isFilled.submitPersonalInformation
      ? props.isFilled.middle_name
      : "",
    last_name: props.dsmOnboarding
      ? props.dsmOnboarding.last_name
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.last_name
      : "",
    email: props.dsmOnboarding
      ? props.dsmOnboarding.email
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.email
      : "",
    phone_no: props.dsmOnboarding
      ? props.dsmOnboarding.phone_no.split("").splice(3).join("")
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.phone_no.split("").splice(3).join("")
      : "",
    // fees: props.isFilled.submitPersonalInformation
    //   ? props.isFilled.fees
    //   : Number,
    years_of_experience: props.isFilled.submitPersonalInformation
      ? props.isFilled.years_of_experience
      : Number,
    doctor_specialization_id: props.dsmOnboarding
      ? props.dsmOnboarding.specialization_id
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.doctor_specialization_id
      : "",
    state_code: props.isFilled.submitPersonalInformation
      ? props.isFilled.state_code
      : Number,
    address: props.isFilled.submitPersonalInformation
      ? props.isFilled.address
      : "",
    zipcode: props.isFilled.submitPersonalInformation
      ? props.isFilled.zipcode
      : "",
    // about: props.isFilled.submitPersonalInformation ? props.isFilled.about : "",
    degree: props.dsmOnboarding
      ? props.dsmOnboarding.education
      : props.isFilled.submitPersonalInformation
      ? props.isFilled.education
      : "",
    // description: props.isFilled.submitPersonalInformation
    //   ? props.isFilled.description
    //   : "",
  };

  useEffect(() => {
    setState({
      ...state,
      selectedSpecialisation: props.dsmOnboarding
        ? props.dsmOnboarding.specialization_name
        : props.isFilled.submitPersonalInformation
        ? props.isFilled.doctor_specialization_id
        : "",
    });
  }, [props.dsmOnboarding.specialization_name, state.doctorCategories]);

  useEffect(() => {
    afterLoginApiAxios
      .get("public/get-doctor-categories")
      .then((response) => {
        if (response.data.statusCode === 200) {
          // let defaultOption = { value: "999999", label: "Others..." };
          let doctorCategories = response.data.categories.map((categories) => {
            return {
              value: categories.id,
              label: categories.display_name,
            };
          });
          // doctorCategories.unshift(defaultOption);
          return setState({
            ...state,
            doctorCategories: doctorCategories,
          });
        }
        swal({
          title: "Something went Wrong!",
          icon: "error",
          message: response.data.message,
        });
      })
      .catch((e) => {
        if (e.status === 403)
          return internalServerError(
            "Some internal Server Error",
            props.history
          );

        internalServerError("", props.history);
      });
  }, [props.dsmOnboarding.specialization_name]);

  const asyncHandler = (e, setFieldValue, selectedOption) => {
    if (e.value === "999999") {
      setFieldValue([selectedOption.name], e.value);
      state.selectedSpecialisation = e.value;
      state.specifyOthers = true;
      state.specializationError = false;
      setState({
        ...state,
      });
    } else if (selectedOption.name == "doctor_specialization_id") {
      setFieldValue([selectedOption.name], e.value);
      state.selectedSpecialisation = e.value;
      state.specifyOthers = false;
      state.specializationError = false;
      setState({
        ...state,
      });
    } else if (selectedOption.name == "state_code") {
      setFieldValue([selectedOption.name], e.value);
      state.state_code = e.value;
      state.selectedStateError = false;
      setState({
        ...state,
      });
    }
  };

  const asyncBlurHandler = (selectedFieldName, setFieldTouched) => {
    if (selectedFieldName == "doctor_specialization_id") {
      let specializationError =
        state.selectedSpecialisation == "" ? true : false;
      state.specializationError = specializationError;
      setState({ ...state });
      setFieldTouched("doctor_specialization_id", true);
    } else if (selectedFieldName == "state_code") {
      let selectedStateError =
        state.state_code.toString() == "function Number() { [native code] }"
          ? true
          : false;
      state.selectedStateError = selectedStateError;
      setState({ ...state });
      setFieldTouched("state_code", true);
    }
  };

  const handleBlurSpecificField = (e) => {
    let otherSpecializationError = !!state.specifiedSpecilization.trim()
      ? false
      : true;
    setState({ ...state, otherSpecializationError: otherSpecializationError });
  };

  const handleSpecifiedField = (e) => {
    let otherSpecializationError = !!e.target.value.trim() ? false : true;
    setState({
      ...state,
      [e.target.name]: e.target.value,
      otherSpecializationError: otherSpecializationError,
    });
  };

  const customerFiler = (option, rawInput) => {
    const words = rawInput.split(" ");
    return words.reduce(
      (acc, cur) =>
        acc && option.label.toLowerCase().startsWith(cur.toLowerCase()),
      true
    );
  };

  const submitHandler = async (allValues, { setSubmitting, resetForm }) => {
    const values = PersonalInformationSchema.cast(allValues);
    // values.fees = parseFloat(values.fees);
    values.years_of_experience = parseFloat(values.years_of_experience);

    if (state.selectedSpecialisation == "") {
      setState({
        ...state,
        specializationError: true,
        ...values,
      });
      return;
    }
    if (state.state_code.name == "Number") {
      setState({
        ...state,
        selectedStateError: true,
        ...values,
      });
      return;
    }
    if (
      state.selectedSpecialisation == "999999" &&
      !state.specifiedSpecilization.trim()
    ) {
      setState({
        ...state,
        otherSpecializationError: true,
        ...values,
      });
      return;
    }
    setSubmitting(true);
    setState({
      ...state,
      loading: true,
      ...values,
    });
    API_Call.post("/public/create-doctor-onboard-application", {
      doctor_application_id: localStorage.getItem("doctor_application_id")
        ? localStorage.getItem("doctor_application_id")
        : "",
      step: "1",
      new_specialization_text: state.specifiedSpecilization
        ? state.specifiedSpecilization
        : "",
      ...values,
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.statusCode === 200) {
            setState({
              ...state,
              ...values,
              submitPersonalInformation: true,
              loading: false,
            });
            localStorage.setItem(
              "doctor_application_id",
              response.data.user_id
            );
            const Msg = swal({
              title: "Data Saved Successfully",
              icon: "success",
              button: "OK",
            }).then(() => {
              props.submitData({
                ...values,
                ...state,
                submitPersonalInformation: true,
              });
            });
            return Msg;
          } else {
            setState({ ...state, loading: false });
            const Msg = swal({
              title: "Invalid Submission",
              text: response.data.message
                ? response.data.message
                : response.data.errorMessage,
              icon: "warning",
              button: "OK",
            });
            return Msg;
          }
        } else {
          setState({ ...state, loading: false });
          const Msg = swal({
            title: "Server Error",
            text: "Something went wrong",
            icon: "danger",
            button: "OK",
          });
          return Msg;
        }
      })
      .catch((err) => {
        setState({ ...state, loading: false });
        const Msg = swal({
          title: "Server Error",
          text: err.message,
          icon: "danger",
          button: "OK",
        });
        return Msg;
      });
    setTimeout(function () {
      props.refetchapi();
    }, 2000);
    setredo(redo + 1);
  };
  const renderErrors = (errors, touched) => {
    let errorsToRender = [];
    for (let error in errors) {
      if (touched[error] && error !== "status" && error !== "is_agreed") {
        let errorToRender = errors[error];
        errorToRender = errorToRender[0].toUpperCase() + errorToRender.slice(1);
        errorsToRender.push(errorToRender);
      }
    }
    if (errorsToRender.length > 1)
      return (
        <div className={"invalid-feedback d-block"}>
          Please fill all the mandatory fields
        </div>
      );
    if (state.otherSpecializationError && state.specifyOthers) {
      errorsToRender.push("Specific Specialization is required");
    }
    return errorsToRender.map((error) => (
      <div className={"invalid-feedback d-block"}>{error}</div>
    ));
  };

  return (
    <Fragment>
      {state.loading ? <Loader /> : null}
      <section
        id="side_tab1"
        className="item active"
        data-title="Personal Information"
      >
        <div className="item-content">
          <div className="personal-info">
            <div className="info-ttl">
              <h2>Personal Information</h2>
            </div>
            <div className="info-form">
              <Formik
                onSubmit={submitHandler}
                initialValues={initialFieldValues}
                validationSchema={PersonalInformationSchema}
                enableReinitialize={true}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  handleBlur,
                  errors,
                  touched,
                  isSubmitting,
                  setValues,
                  setFieldTouched,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit} noValidate={true}>
                    <div className="row">
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <Form.Label>Prefix </Form.Label>
                          <Form.Control
                            type="text"
                            name="prefix_name"
                            className="cstom-control"
                            placeholder="Prefix"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.prefix_name}
                            isInvalid={
                              errors.prefix_name && touched.prefix_name
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.prefix_name}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            First Name <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            name="first_name"
                            className="cstom-control"
                            placeholder="First Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.first_name}
                            isInvalid={errors.first_name && touched.first_name}
                            disabled={props.dsmOnboarding ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.first_name}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      {/*
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>Middle Name</label>
                          <Form.Control
                            type="text"
                            name="middle_name"
                            className="cstom-control"
                            placeholder="Middle Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.middle_name}
                            isInvalid={
                              errors.middle_name && touched.middle_name
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.middle_name}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      */}
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>Last Name </label>
                          <Form.Control
                            type="text"
                            name="last_name"
                            className="cstom-control"
                            placeholder="Last Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.last_name}
                            isInvalid={errors.last_name && touched.last_name}
                            disabled={props.dsmOnboarding ? true : false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.last_name}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-8 col-sm-10">
                        <div className="form-group">
                          <label>
                            Email <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            name="email"
                            className="cstom-control"
                            placeholder="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            isInvalid={errors.email && touched.email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Phone Number <span>*</span>
                          </label>
                          <PhoneInput
                            type="tel"
                            maxlength="10"
                            required
                            name="phone_no"
                            className="cstom-control"
                            placeholder="Phone number"
                            initialValue={values.phone_no}
                            value={values.phone_no}
                            isInvalid={errors.phone_no && touched.phone_no}
                            onBlur={handleBlur}
                            onChange={(v) => setFieldValue("phone_no", v)}
                            errorFeedback={
                              <Form.Control.Feedback type="invalid">
                                {errors.phone_no}
                              </Form.Control.Feedback>
                            }
                          />
                          {/* <span className="cntry-code">+91</span> */}
                        </div>
                      </div>
                      {/* <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Fees<span>*</span>
                          </label>
                          <Form.Control
                            type="number"
                            required
                            name="fees"
                            className="cstom-control"
                            placeholder="Fees in INR"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.fees}
                            isInvalid={errors.fees && touched.fees}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.fees}
                          </Form.Control.Feedback>{" "}
                        </div>
                      </div> */}
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Experience <span>*</span>
                          </label>
                          <Form.Control
                            type="number"
                            required
                            name="years_of_experience"
                            className="cstom-control"
                            placeholder="Yrs of Exp"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.years_of_experience}
                            isInvalid={
                              errors.years_of_experience &&
                              touched.years_of_experience
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.years_of_experience}
                          </Form.Control.Feedback>{" "}
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Specialization <span>*</span>
                          </label>
                          <div>
                            <Select
                              name="doctor_specialization_id"
                              id="slct"
                              placeholder="Doctor Specialization"
                              options={state.doctorCategories}
                              filterOption={customerFiler}
                              onChange={(e, selected) =>
                                asyncHandler(e, setFieldValue, selected)
                              }
                              onBlur={() =>
                                asyncBlurHandler(
                                  "doctor_specialization_id",
                                  setFieldTouched
                                )
                              }
                              style={{ width: "100%" }}
                              value={
                                state.doctorCategories
                                  ? state.doctorCategories.find(
                                      (categories) => {
                                        if (
                                          categories.value ==
                                          values.doctor_specialization_id
                                        ) {
                                          return categories.label;
                                        }
                                      }
                                    )
                                  : values.doctor_specialization_id.label
                              }
                              isOptionDisabled={(option) =>
                                option.value === "999999"
                              }
                            />
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {state.specializationError
                                ? "Specialization is required"
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-lg-4 col-sm-6"
                        style={
                          state.specifyOthers
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        <div className="form-group">
                          <label>
                            Specify your Specialization <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            name="specifiedSpecilization"
                            className="cstom-control"
                            placeholder="Enter your Specialization..."
                            value={state.specifiedSpecilization}
                            onBlur={handleBlurSpecificField}
                            onChange={handleSpecifiedField}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {state.otherSpecializationError
                              ? "Specialization is required"
                              : ""}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Degree <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            name="degree"
                            className="cstom-control"
                            placeholder="Degree"
                            value={values.degree}
                            isInvalid={errors.degree && touched.degree}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.degree}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            State <span>*</span>
                          </label>
                          <div>
                            <Select
                              name="state_code"
                              id="slct"
                              placeholder="State"
                              options={state.selectState}
                              filterOption={customerFiler}
                              onChange={(e, selected) =>
                                asyncHandler(e, setFieldValue, selected)
                              }
                              onBlur={() =>
                                asyncBlurHandler("state_code", setFieldTouched)
                              }
                              value={state.selectState.find((states) => {
                                if (states.value == values.state_code) {
                                  return states.label;
                                }
                              })}
                            />
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {state.selectedStateError
                                ? "State is required"
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6">
                        <div className="form-group">
                          <label>
                            Pincode <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            maxLength="6"
                            className="cstom-control"
                            placeholder="Pincode"
                            name="zipcode"
                            value={values.zipcode}
                            isInvalid={errors.zipcode && touched.zipcode}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.zipcode}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="form-group">
                          <label>
                            Address <span>*</span>
                          </label>
                          <Form.Control
                            as="textarea"
                            required
                            className="cstom-control"
                            placeholder="Address"
                            name="address"
                            value={values.address}
                            isInvalid={errors.address && touched.address}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      {/* <div className="col-lg-10 col-sm-10">
                        <div className="form-group">
                          <label>Associated With</label>
                          <Form.Control
                            type="text"
                            placeholder="Kindly mention the hospitals/institutes you are associated with"
                            name="about"
                            value={values.about}
                            isInvalid={errors.about && touched.about}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.about}
                          </Form.Control.Feedback>
                        </div>
                      </div> */}
                      {/* <div className="col-lg-12 col-sm-12">
                        <div className="form-group">
                          <label>Description</label>
                          <Form.Control
                            as={"textarea"}
                            type="text"
                            name="description"
                            className="cstom-text-control"
                            placeholder="Kindly provide a brief profile description here"
                            value={values.description}
                            isInvalid={
                              errors.description && touched.description
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.description}
                          </Form.Control.Feedback>
                        </div>
                      </div> */}
                    </div>
                    <div className="save-next">
                      <Button
                        variant="primary"
                        type="submit"
                        className="custom-btnn d-block"
                        disabled={isSubmitting}
                      >
                        Save & Proceed <i className="fa fa-angle-right"></i>
                      </Button>
                    </div>
                    <div className={"d-flex mt-3"}>
                      <div className="ml-auto">
                        {renderErrors(errors, touched)}
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default withRouter(PersonalInformation);
